// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2aluH","inputDescription":"styles_inputDescription__E3rj8"};